<template>
  <v-app-bar density="compact" height="40" color="grey-lighten-4" v-if="district" flat>
    <template v-slot:title>
      <v-sheet color="transparent" class="d-flex justify-center align-center">
        <v-btn icon size="small" density="compact" v-on:click="sub_week()">
          <v-icon :icon="['fas', 'arrow-left']" />
          <v-tooltip activator="parent" location="bottom start">
            ПРЕДЫДУЩАЯ
          </v-tooltip>
        </v-btn>
        <v-btn icon size="small" density="compact" v-on:click="set_current_week()" v-if="!is_current">
          <v-icon :icon="['fas', 'house']" />
          <v-tooltip activator="parent" location="bottom start">
            К ТЕКУЩЕЙ
          </v-tooltip>
        </v-btn>
        <p class="mx-2" style="font-size: 12px; opacity: 0.5">{{ `${current_period.format('w [неделя] YYYY [года]')}`.toUpperCase() }} | {{ current_months }} </p>

        <v-btn icon size="small" density="compact" v-on:click="add_week()">
          <v-icon :icon="['fas', 'arrow-right']" />
          <v-tooltip activator="parent" location="bottom end">
            СЛЕДУЮЩАЯ
          </v-tooltip>
        </v-btn>
      </v-sheet>
    </template>
    <template v-slot:append>
      <ToggleWeekends__WP_Widget />
      <v-btn icon v-on:click="go_to_print()" density="compact" color="green">
        <v-icon :icon="['fas', 'print']" />
        <v-tooltip activator="parent" location="bottom">
          Печать
        </v-tooltip>
      </v-btn>
      <Filter__WP_Dialog />
      <Settings__WP_Dialog />
      <SaveData__WP_Dialog />
    </template>
  </v-app-bar>

  <CurrentEvent__WP_Alert />
</template>

<script>

import moment from "moment/moment";
import { CurrentElement } from "@/store/wp_planner/events.store";
import { District__Info } from "@/store/global/districts.dictionary";
import { CurrentPeriod } from "@/store/wp_planner/main.store";
import CurrentEvent__WP_Alert from "@/components/wp_planner/alerts/current_dragging.alert.vue";
import { WeekDura } from "@/store/wp_planner/specialists.store";
import { update_all } from "@/libs/wp/update_registered";
import { TokenGUIDStore } from "@/store/global/SessionStore";
import SaveData__WP_Dialog from "@/components/wp_planner/dialogs/save_data.dialog.vue";
import Filter__WP_Dialog from "@/components/wp_planner/dialogs/filter.dialog.vue";
import Settings__WP_Dialog from "@/components/wp_planner/dialogs/settings.dialog.vue";
import ToggleWeekends__WP_Widget from "@/components/wp_planner/widgets/toggleweekends.widget.wp.vue";

export default {
  name: "HeaderArea__WP_View",
  components: {
    CurrentEvent__WP_Alert,
    ToggleWeekends__WP_Widget,
    Filter__WP_Dialog,
    SaveData__WP_Dialog,
    Settings__WP_Dialog
  },
  async beforeMount() {
    await this.get_district_data()
  },
  methods: {
    get_district_data: async function () {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.ONETEST}/GetDistrictData`
      let raw = {
        district: this.$route.params.district
      }
      let properies = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        },
        body: JSON.stringify(raw)
      }
      console.log(properies)

      await fetch(url, properies)
          .then(async response => {
            if (response.ok) {
              return await response.json()
            } else {
              throw `Ошибка получения Документов!`
            }
          })
          .then(result => {
            console.log(result)
            this.district = result
          }).catch(err => {
            console.error(err)
          })
    },
    go_to_print: function () {
      this.$router.push({ name: 'wp__print', params: { district: this.$route.params.district } })
    },
    set_current_week: function () {
      this.ext_week = null
      this.current_period = moment()
    },
    add_week: function () {
      this.ext_week = null
      this.current_period = moment(this.current_period).add(1, 'weeks')
    },
    sub_week: function () {
      this.ext_week = null
      this.current_period = moment(this.current_period).subtract(1, 'weeks')
    }
  },
  watch: {
    async current_period() {
      await update_all(
          this.session_token,
          this.$route.params.district,
          moment(this.current_period).year(),
          moment(this.current_period).week()
      )
    }
  },
  computed: {
    is_current() {
      return this.current_period.startOf('week').format('DD.MM.YYYY') === moment().startOf('week').format('DD.MM.YYYY')
    },
    session_token() {
      return TokenGUIDStore().get()
    },
    current_months() {
      let months = []
      let start_week = moment(this.current_period).format('MMMM')
      let end_week   = moment(this.current_period).endOf("week").format("MMMM");
      months.push(start_week)
      if (!months.includes(end_week)) months.push(end_week)
      if (months.length === 1) {
        return `${months[0].toUpperCase()}`
      } else {
        return `${months[0].toUpperCase()} - ${months[1].toUpperCase()}`
      }
    },
    ext_week: {
      get() {
        return WeekDura().get()
      },
      set(value) {
        WeekDura().set(value)
      }
    },
    current_dragging: {
      get() {
        return CurrentElement().get()
      },
      set(value) {
        CurrentElement().set(value)
      }
    },
    district: {
      get() {
        return District__Info().get()
      },
      set(value) {
        District__Info().set(value)
      }
    },
    current_period: {
      get() {
        return CurrentPeriod().get()
      },
      set(value) {
        CurrentPeriod().set(value)
      }
    }
  }
}
</script>

<style scoped>

</style>
